import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material';
import { Outlet } from 'react-router';
import { useRuntimeConfig } from '../config/runtime-config';

/** Mobile-first layout for participants (§48–§53) with privacy/imprint links (§63). */
export function PublicLayout() {
  const config = useRuntimeConfig();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
      }}
    >
      <Box
        component="header"
        sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', py: 2 }}
      >
        <Container maxWidth="sm">
          <Typography component="p" variant="h3">
            Lernplattform – Zugang
          </Typography>
        </Container>
      </Box>
      <Container component="main" id="main" maxWidth="sm" sx={{ flex: 1, py: { xs: 3, sm: 5 } }}>
        <Outlet />
      </Container>
      <Divider />
      <Container component="footer" maxWidth="sm" sx={{ py: 3 }}>
        <Stack direction="row" spacing={3} sx={{ flexWrap: 'wrap' }}>
          <Link href={config.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
            Datenschutzerklärung
          </Link>
          {config.imprintUrl ? (
            <Link href={config.imprintUrl} target="_blank" rel="noopener noreferrer">
              Impressum
            </Link>
          ) : null}
        </Stack>
      </Container>
    </Box>
  );
}
